import axios from "axios";
import { API } from "@/lib/api";

// IMPORTANT: Admin uses a single shared password sent as the X-Admin-Password
// HEADER on every request — it is NOT a JWT/session token. localStorage is the
// intentional storage mechanism: switching to httpOnly cookies would require a
// full server-side session rewrite for zero security gain, because any XSS-
// capable script could hit /api/admin/* directly anyway. The static-analyzer
// "localStorage = insecure" warning is a false positive for this design.
const TOKEN_KEY = "ymp_admin_token";

export const adminGetToken = () => localStorage.getItem(TOKEN_KEY);
export const adminSetToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const adminClearToken = () => localStorage.removeItem(TOKEN_KEY);

const adminClient = () =>
    axios.create({
        baseURL: API,
        headers: {
            "Content-Type": "application/json",
            "X-Admin-Password": adminGetToken() || "",
        },
    });

export const adminLogin = async (password) => {
    const res = await axios.post(`${API}/admin/login`, { password });
    adminSetToken(res.data.token);
    return res.data;
};

export const adminSummary = () => adminClient().get("/admin/summary");
export const adminApplications = () =>
    adminClient().get("/admin/applications");
export const adminPartnerships = () =>
    adminClient().get("/admin/partnerships");
export const adminContacts = () => adminClient().get("/admin/contacts");
